module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/readable-stream/~/isarray/index.js
 ** module id = 749
 ** module chunks = 2
 **/